<template>
    <simple-layout>
        <basic-card>
            <template slot="header">
                {{ $t("files.filesCaption") }}
            </template>
            <simple-list
              ref="importFileList"
              object-name="importFile"
              query-store-name="importFile"
              :columns="importFileColumns"
              :actions="importFileActions"
              @delete="confirmDelete"
              @editFile="editFile"
              @importFile="importFile"
              @downloadFile="downloadFile"
            />

        </basic-card>
        <v-modal name="fileImportModal" classes="transparent-modal" style="background-color: rgba(10,10,10,0.66); padding-bottom: 40px;"
                 :width="800" :height="800">
            <basic-card v-if="fileToImport !== null">
                <template slot="header">
                    Zpracování souborů
                </template>
                Import souboru {{ fileToImport.fileName }}
                <form-wrapper>
                    <form-text-input caption="Source" v-model="fileSource"/>
                    <form-select-input caption="Import definition" v-model="fileImportDefinition"
                                       :options="importDefinitionOptions"/>
                </form-wrapper>
                <simple-button @press="doImport">Zprocesuj vybrané</simple-button>
            </basic-card>
        </v-modal>
        <v-modal name="fileDeleteModal" classes="transparent-modal" style="background-color: rgba(10,10,10,0.66)"
                 :width="800" :height="600">
            <basic-card v-if="fileToDelete !== null">
                <template slot="header">
                    Confirmation
                </template>
                Please confirm deletion of file with name: <b>{{ fileToDelete.fileName }}</b>
                <br/><br/>
                <simple-layout horizontal>
                    <simple-button @press="cancelDelete">{{ $t("cancel") }}</simple-button>
                    <simple-button @press="deleteFile(fileToDelete)">Delete</simple-button>
                </simple-layout>
            </basic-card>
        </v-modal>
        <v-modal name="fileEditModal" classes="transparent-modal" style="background-color: rgba(10,10,10,0.66)"
                 :width="800" :height="600">
            <basic-card v-if="fileToEdit !== null">
                <template #header>
                    {{ $t('editation') }}
                </template>
                <form-wrapper>
                    <form-text-input :caption="$t('files.category')" v-model="fileToEdit.category"/>
                    <form-text-input :caption="$t('files.customName')" v-model="fileToEdit.customName"/>
                </form-wrapper>


                <br/><br/>
                <simple-layout horizontal>
                    <simple-button @press="cancelEdit">{{ $t("cancel") }}</simple-button>
                    <simple-button @press="confirmEdit">{{ $t("save") }}</simple-button>
                </simple-layout>
            </basic-card>
        </v-modal>
    </simple-layout>
</template>

<script>
import SimpleLayout from "../components/layout/SimpleLayout";
import BasicCard from "../components/layout/BasicCard";
import DataTable from "../components/table/DataTable";
import { mapGetters } from "vuex";
import FormSelectInput from "../components/form/FormSelectInput";
import FormTextInput from "../components/form/FormTextInput";
import FormWrapper from "../components/form/FormWrapper";
import SimpleButton from "../components/button/SimpleButton";
import Axios from 'axios'
import SimpleList from "@/components/lists/SimpleList";
import CollapsibleContent from "@/components/CollapsibleContent";
import SimpleHorizontalLayout from "@/components/layout/SimpleHorizontalLayout";
import QueryUtils from "@/utils/QueryUtils";
import FilterForm from "@/components/filters/FilterForm";
import Empty from "@/components/layout/Empty";

export default {
    name: "ImportFilesView",
    components: {
        Empty,
        FilterForm,
        SimpleHorizontalLayout,
        CollapsibleContent,
        SimpleList,
        SimpleButton, FormWrapper, FormTextInput, FormSelectInput, DataTable, BasicCard, SimpleLayout
    },
    data: function () {
        return {
            fileSource: "default",
            fileToImport: null,
            fileToDelete: null,
            fileToEdit: null,
            fileImportDefinition: null,
            importFileColumns: [
                {
                    caption: "ID",
                    datum: d => d.id
                },
                {
                    caption: this.$t('files.fileName'),
                    datum: d => d.fileName
                },
                {
                    caption: this.$t('files.mimeType'),
                    datum: d => d.mimeType
                },
                {
                    caption: this.$t('files.timeStamp'),
                    datum: d => new Date(d.timeStamp).toLocaleString()
                },
                {
                    caption: this.$t('files.category'),
                    datum: d => d.category
                },
                {
                    caption: this.$t('files.customName'),
                    datum: d => d.customName
                }
            ],
            importFileActions: [
                {
                    icon: 'file-import',
                    name: 'importFile',
                    accessLambda: (d) => true,
                    tooltip: this.$t('files.startImport')
                },
                {
                    icon: 'edit',
                    name: 'editFile',
                    accessLambda: (d) => true,
                    tooltip: this.$t('files.edit')
                },
                {
                    icon: 'download',
                    name: 'downloadFile',
                    accessLambda: (d) => true,
                    tooltip: this.$t('files.download')
                }
            ],
            query: null,
            selectedQuery: null,
            selectedQueryName: null,
        }
    },
    methods: {
        importFile(file) {
            this.fileToImport = file;
            this.$modal.show("fileImportModal");
        },
        editFile(file) {
            this.fileToEdit = this.$_.cloneDeep(file);
            this.$modal.show("fileEditModal");
        },
        cancelEdit() {
            this.fileToEdit = null;
            this.$modal.hide("fileEditModal");
        },
        async confirmEdit() {
            console.log('FILE TO EDIT', this.fileToEdit)
            try {
                this.fileToEdit.timeStamp = undefined;
                const url = `resource/api/v1/files/${this.fileToEdit.id}`;
                await Axios.put(url, this.fileToEdit);
                this.$notify({
                    group: 'application',
                    title: this.$t('files.saveSuccess'),
                    text: this.$t('files.saveSuccess'),
                    type: "ok"
                });

                await this.$refs.importFileList.refreshData();

                this.fileToEdit = null;
                this.$modal.hide("fileEditModal");
            } catch (error) {
                this.$notify({
                    group: 'application',
                    title: this.$t('files.saveError'),
                    text: this.$t('files.saveError'),
                    type: "error"
                });
            }
        },
        cancelDelete() {
            this.fileToDelete = null;
            this.$modal.hide("fileDeleteModal");
        },
        confirmDelete(file) {
            this.fileToDelete = file;
            this.$modal.show("fileDeleteModal");
        },
        deleteFile(file) {
            this.$modal.hide("fileDeleteModal");
            this.$store.dispatch("importFiles/deleteImportFile", file)
              .then(() => {
                  this.$notify({
                      group: 'application',
                      title: `Import file deleted`,
                      text: `Import file ${file.fileName} deleted`,
                      type: "ok"
                  })
              })
        },
        downloadFile(file) {
            Axios.get(`/resource/api/v1/files/${file.id}/data`, {
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', file.fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
        },
        doImport() {
            Axios.post("processing/api/v1/processes", {
                  values: {
                      file: `http://opentreasury/resource/api/v1/files/${this.fileToImport.id}/data`,
                      source: this.fileSource
                  },
                  definitionId: this.fileImportDefinition,
              }
            ).then(res => {
                if (res.status === 204) {
                    this.$notify({
                        group: 'application',
                        title: `Import started`,
                        text: `Import of file ${this.fileToImport.fileName} started`,
                        type: "ok"
                    })
                } else if (res.status === 409) {
                    this.$notify({
                        group: 'application',
                        title: 'Import failed',
                        text: `Import of file ${this.fileToImport.fileName} didn't start, because of other import in progress`,
                        type: "error"
                    })
                }
                this.$modal.hide("fileImportModal");
            })
        }
    },
    computed: {
        ...mapGetters({
            importFiles: "importFiles/importFiles",
            importFileQueries: "importFileQueries/importFileQueries",
            importDefinitionOptions: "importDefinitions/importDefinitionOptions"
        }),
        importFileQueryOptions() {
            console.log(this.importFileQueries);
            return this.importFileQueries
              .filter(query => query.object === 'importFile')
              .map(query => ({id: query.id, name: query.name == null ? "No-name" : query.name}))
        },
        importFileQueryDefinition() {
            return QueryUtils.getByType("importFile");
        },
        importFilesAdjusted() {
            return this.importFiles.reverse();
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
